/** Sprite key → SVG source. Authoring rules:
 *   - viewBox in art pixels (1 cell = 8). 1×1 → "0 0 8 8", 2×1 → "0 0 16 8".
 *   - +x right, +y down (SVG). Ship "forward" = +x. Draw in facing=0.
 *   - Thrusters (ThrusterPort.dir=0 pushes +x): bell on LEFT, plume out left.
 *   - Weapons/Sensors/Collector (facing 0 → +x): muzzle/lens on RIGHT.
 *   - Cockpit (facing 0): windows on RIGHT. */
export type SpriteSource = {
  svg: string;
  /** width in art-pixels (= cells.w × 8). */
  width: number;
  height: number;
};
const REGISTRY = new Map<string, SpriteSource>();

export function registerSprite(key: string, source: SpriteSource): void {
  if (REGISTRY.has(key)) throw new Error(`duplicate sprite key: ${key}`);
  REGISTRY.set(key, source);
}

export function getSprite(key: string): SpriteSource {
  const s = REGISTRY.get(key);
  if (!s) throw new Error(`missing sprite: ${key}`);
  return s;
}

export function spriteKeys(): string[] {
  return [...REGISTRY.keys()];
}
